exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Copyright (c) 2020 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.mychart{height:auto;width:auto}.chart-container{position:relative;margin:auto}.legend-con{font-family:FontAwesome,sans-serif;display:inline-block}.legend-con ul{list-style:none}.legend-con li{display:flex;align-items:center;margin-bottom:4px}.legend-con li span{display:inline-block}.legend-con li span.chart-legend{width:25px;height:25px;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/component/dv-pie-charts/dv-pie-charts.scss
// module id = n/H1
// module chunks = 0